module.exports = __webpack_public_path__ + "img/28.10.pH.00d82212.png";